/**
 * This files includes default lookup calls data, as our api fails , we will serve this data into our apis
 * List of lookups api & its variable
 * /lookup/salutations      - DEFAULT_SALUTATION_DATA
 
 * /lookup/countries        --> not used, deleted (DEFAULT_COUNTRIES_DATA)
 * /lookup/identity-types   --> not used, deleted (DEFAULT_IDENTITY_TYPES_DATA)
 * /lookup/nationalities    --> not used, deleted (DEFAULT_NATIONALITIES_DATA)
 * /lookup/mnp-prefixes     --> not used, deleted (DEFAULT_MPN_PROVIDER_DATA)
 * /lookup/providers        --> not used, deleted (DEFAULT_PROVIDERS_DATA)
 *
 */

export const DEFAULT_SALUTATION_DATA = [
  {
    id: 3,
    value: 'Herr/Frau'
  },
  {
    id: 2,
    value: 'Frau'
  },
  {
    id: 1,
    value: 'Herr'
  }
];

export default {
  DEFAULT_SALUTATION_DATA,
};
